import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AdminAddResources from '../../ui/AdminAddResources';
import AdminAllResources from '../../ui/AdminAllResources';

const ResourcesSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState('allResources');
  const [edit, setEdit] = useState({ isEdit: false, item: {} as any });

  const handleEdit = (item: any) => {
    setEdit({ isEdit: true, item });
    setActiveTab('addResource');
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <h1>Add Resources</h1>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full grid-cols-2 lg:w-[400px]">
            <TabsTrigger value="addResource">Add Resources</TabsTrigger>
            <TabsTrigger value="allResources">All Resources</TabsTrigger>
          </TabsList>

          <TabsContent value="addResource" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle>
                  <h1>{edit.isEdit ? 'Update Resource' : 'Add Resource'}</h1>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <AdminAddResources editData={edit} setEdit={setEdit} />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="allResources" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle></CardTitle>
              </CardHeader>
              <CardContent>
                <AdminAllResources handleUpdate={handleEdit} />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default ResourcesSection;


